let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("96g6X")).then(() => parcelRequire('8LbPV'));